"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var FundDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FundDetail, _super);
    function FundDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '基金详情';
        _this.code = '106005';
        _this.desc = '基金详情';
        _this.requestParams = new zl_1.FundDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FundDetail;
}(service_1.BaseService));
exports.FundDetail = FundDetail;
//# sourceMappingURL=fundDetail.js.map